import common from './en-US/common';
import report from './en-US/report';
import contentManagementCenter from './en-US/contentManagementCenter';
import userDataCenter from './en-US/userDataCenter';
import quarterReport from './en-US/quarterReport';
import yearReport from './en-US/yearReport';
import personalTokenCenter from './en-US/personalTokenCenter';

export default {
  ...common,
  ...report,
  ...contentManagementCenter,
  ...userDataCenter,
  ...quarterReport,
  ...yearReport,
  ...personalTokenCenter,
};
